module.exports = __webpack_public_path__ + "img/twitter.7f36e2d7.svg";